import { render, staticRenderFns } from "./stageList.vue?vue&type=template&id=5282f740&scoped=true"
import script from "./stageList.vue?vue&type=script&lang=js"
export * from "./stageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282f740",
  null
  
)

export default component.exports